import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'

export default function useSearchLinks({ nonReligiousMode }) {
  const { t } = useTranslation()

  const searchLinks = {
    id: 'search',
    text: t('nav.search', 'Search'),
    sub: [
      { id: 'records', text: t('nav.search.records', 'Records'), url: '/search/' },
      { id: 'images', text: t('nav.records.images', 'Images'), url: '/records/images' },
      { id: 'find_in_family_tree', text: t('nav.family-tree', 'Family Tree'), url: '/search/tree?from=search' },
      { id: 'genealogies', text: t('nav.search.genealogies', 'Genealogies'), url: '/search/genealogies' },
      { id: 'catalog', text: t('nav.search.catalog', 'Catalog'), url: '/search/catalog' },
      {
        id: 'books',
        text: t('nav.search.books', 'Books'),
        url: 'https://www.familysearch.org/library/books',
      },
      {
        id: 'wiki',
        text: t('nav.research-wiki', 'Research Wiki'),
        url: `/${i18n.language}/wiki/${t('nav.research-wiki.url', 'Main_Page')}`,
      },
      {
        id: 'cemeteries',
        text: t('nav.search.cemeteries', 'Cemeteries'),
        url: `/${i18n.language}/cemeteries`,
      },
    ],
  }

  searchLinks.sub = searchLinks.sub.filter((link) => {
    let keep = true

    if (
      link.id === 'wiki' &&
      (!['en', 'es', 'pt', 'fr', 'de', 'sv', 'it', 'ru'].includes(i18n.language) || nonReligiousMode)
    ) {
      keep = false
    } else if (link.id === 'books' && (i18n.language !== 'en' || nonReligiousMode)) {
      keep = false
    }

    return keep
  })

  return searchLinks
}
